// Copyright (C) 2020 TANNER AG

import { graphql } from 'react-apollo'
import { compose } from 'recompose'
import withLocalization from './withLocalization'
import withFlattenedTranslations from './withFlattenedTranslations'
import withLoadingState from './withLoadingState'
import withErrorState from './withErrorState'
import withConnectionStatus from './withConnectionStatus'
import podcastsQuery from '../queries/podcasts'

const buildQueryOptions = ({
    language,
    fetchPolicy,
    podcastsFrist,
    podcastsSkip,
    stage
}) => {
    return {
        variables: {
            lang: language.toLowerCase(),
            first: podcastsFrist,
            skip: podcastsSkip,
            stage
        },
        fetchPolicy
    }
}

export default customLoadingComponent =>
    compose(
        withConnectionStatus,
        withLocalization,
        graphql(podcastsQuery, {
            options: props => {
                return buildQueryOptions(props)
            }
        }),
        withErrorState,
        withLoadingState('podcasts', customLoadingComponent, customLoadingComponent),
        withFlattenedTranslations('podcasts'),
    )



// WEBPACK FOOTER //
// ./src/hocs/withPodcasts.js